import {ProductData} from "../cart.dto";
import ProductQuantity from "@/components/ProductQuantity/ProductQuantity";
import React, {useEffect, useState} from "react";
import {useCart} from "../CartContext";
import noImageAvailable from "@/assets/images.png";
import { useLanguage} from "@/components/Navbar/LanguageContext";
import { useCheckUserUM } from "@/components/utils/useCheckUserUM";

function CartItem({
                      productData,
                      itemData,
                  }: {
    productData: ProductData;
    itemData: any;
}) {
    const {removeFromCart, updateCartItemQuantity} = useCart();
    let [quantity, setQuantity] = useState(itemData.quantity);
    const { cart } = useCart();
    const { language } = useLanguage();
    const [userUM, setUserUM] = useState<boolean | null>(null);

    useCheckUserUM((value: boolean) => setUserUM(value));

    useEffect(() => {
        if (quantity !== itemData.quantity) {
            updateCartItemQuantity(itemData.articleId, quantity, productData.isTransit);
        }
    }, [quantity, itemData.articleId, productData.isTransit, itemData.quantity, updateCartItemQuantity]);

    const handleRemove = async () => {
        try {
            await removeFromCart(itemData.articleId, productData.isTransit);
        } catch (error) {
            console.error("Failed to remove item from cart:", error);
        }
    };
    
    return (
        <>
            <li className="flex items-center gap-4 md:max-w-none">
                {productData.articleImage?.mainLink &&
                    <img src={productData.articleImage?.mainLink} alt={"test"}
                         className="size-16 rounded object-cover"/>
                }
                {!productData.articleImage?.mainLink &&
                    <img src={noImageAvailable} alt={"test"}
                         className="size-16 rounded object-cover"/>
                }

                <div>
                    {userUM ? <h3 className="text-sm text-gray-900">{language === "romana" && <a href={"/product/" + productData?.id}
                        >{productData?.displayName}</a>}
                            {language === "franceza" && productData?.longNameFR === null && <a href={"/product/" + productData?.id}
                            >{productData?.displayName}</a>}
                            {language === "franceza" && productData?.longNameFR !== null && <a href={"/product/" + productData?.id}
                            >{productData?.longNameFR}</a>}
                    </h3> :
                        <h3 className="text-sm text-gray-900"><a href={"/product/" + productData?.id}
                        >{productData?.displayName}</a></h3>}

                    <dl className="mt-0.5 space-y-px text-[10px] text-gray-600">
                        <div>
                            <dt className="inline">Id:</dt>
                            <dd className="inline">{productData?.id}</dd>
                        </div>

                        <div>
                            <dt className="inline">TVA:</dt>
                            <dd className="inline">{productData?.vatPercent}%</dd>
                        </div>
                    </dl>
                </div>

                <div className="flex flex-1 items-center justify-end gap-2">
                    <div className="pr-2 flex flex-col">
                        <p className="text-xs">Pret/PCB/BAX fara TVA</p>
                        {(() => {
                            const elSt = cart?.items?.stockItems?.find(el => el.articleId === productData.id);
                            const elTr = cart?.items?.transitItems?.find(el => el.articleId === productData.id);
                            let el;
                            if (elSt !== undefined)
                                el = elSt;
                            else el = elTr;
                            const price = el
                                ? el.thresholdPriceIndex === 1 ? (productData.unitPrice1 ? productData.unitPrice1 : productData.thresholdPrice1).toFixed(2)
                                    : el.thresholdPriceIndex === 2 ? (productData.unitPrice2 ? productData.unitPrice2 : productData.thresholdPrice2).toFixed(2)
                                        : el.thresholdPriceIndex === 3 ? (productData.unitPrice3 ? productData.unitPrice3 : productData.thresholdPrice3).toFixed(2)
                                            : undefined
                                : undefined;
                            return price ? <span>{price} RON</span> : <span className="text-red-500">Indisponibil</span>;
                        })()}
                    </div>
                    <div className="pr-2 flex flex-col">
                        <p className="text-xs">Pret total fara TVA</p>
                        {(() => {
                            const elSt = cart?.items?.stockItems?.find(el => el.articleId === productData.id);
                            const elTr = cart?.items?.transitItems?.find(el => el.articleId === productData.id);
                            let el;
                            if (elSt !== undefined)
                                el = elSt;
                            else el = elTr;
                            const price = el
                                ? el.thresholdPriceIndex === 1 ? (productData.unitPrice1 ? (productData.unitPrice1 * el.quantity) : (productData.thresholdPrice1 * el.quantity)).toFixed(2)
                                    : el.thresholdPriceIndex === 2 ? (productData.unitPrice2 ? (productData.unitPrice2 * el.quantity) : (productData.thresholdPrice2 * el.quantity)).toFixed(2)
                                        : el.thresholdPriceIndex === 3 ? ((productData.unitPrice3 ? (productData.unitPrice3 * el.quantity) : (productData.thresholdPrice3 * el.quantity))).toFixed(2)
                                            : undefined
                                : undefined;
                            return price ? <span>{price} RON</span> : <span className="text-red-500">Indisponibil</span>;
                        })()}
                    </div>
                    <ProductQuantity
                        quantity={quantity}
                        productMultiplier={productData?.multiplier}
                        setQuantity={setQuantity}
                        OnNegativeQuantity={() => {
                            removeFromCart(itemData.articleId, productData.isTransit);
                        }}
                        productData={productData}
                    />

                    <button
                        className="text-gray-600 transition hover:text-red-600"
                        onClick={handleRemove}
                    >
                        <span className="sr-only">Remove item</span>

                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="h-4 w-4"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                            />
                        </svg>
                    </button>
                </div>
            </li>
        </>
    );
}

export default CartItem;
